import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "./OtherRobo.css";
import { getData } from "app/data";
import Button from "components/Button"


export default function Index({ except }) {
  const robots = [];

  getData("robotsData").map((item) => {
    if (item.title !== except) robots.push(item);
  });
  return (
    <section className="also-view">
      <h2>Also View</h2>
      <div className="background">
        <div className="container">
          <div className="row">
            {robots.length > 0
              ? robots.map((item) => (
                  <div className="col-lg-3">
                    <Link to={item.link}>
                      <div className="img-box">
                        <img src={item.img} alt="goopter pudubot" />
                      </div>
                    </Link>
                    <div className="text-box">
                      <h5 className="accent">{item.title}</h5>
                      <p>{item.text}</p>
                      <Button link={item.link} text={<FormattedMessage id="explore" />} accent />
                    </div>
                  </div>
                ))
              : null}
          </div>
        </div>
      </div>
    </section>
  );
}
